export function defaultComicForm() {
  return {
    title: '',
    category: '',
    author: '',
    type: '',
    year: '',
    publishedDate: '',
    original: '',
    imageurl: '',
    description: '',
    pageCount: '',
    language: 'FR',
    date: new Date().toISOString().substring(0, 10),
    read: 'N',
    rating: '3',
    path: 'G:/comics',
    filename: '',
    tag: '',
    marked: '',
    serie: '',
    tome: '',
  }
}

export function appendComicFormData(formData, comic) {
  Object.entries(comic).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value))
    }
  })
}

export function posterSrc(comic) {
  if (comic?.imageurl) return comic.imageurl
  if (comic?.image) return `/uploads/${comic.image}`
  return ''
}

export function googleBooksPosterUrl(volumeInfo) {
  const links = volumeInfo?.imageLinks
  if (!links) return ''

  const url = links.thumbnail || links.smallThumbnail || links.small || links.medium || ''
  if (!url) return ''

  return url.replace(/^http:/, 'https:')
}

export function buildComicSearchQuery(comic) {
  const parts = []
  const title = String(comic?.title || '').trim()
  const author = String(comic?.author || '').trim()
  if (title) parts.push(`intitle:${title}`)
  if (author) parts.push(`inauthor:${author}`)
  return parts.join(' ')
}

function compareTome(a, b) {
  const tomeA = parseFloat(a.tome)
  const tomeB = parseFloat(b.tome)
  const numA = Number.isFinite(tomeA) ? tomeA : Infinity
  const numB = Number.isFinite(tomeB) ? tomeB : Infinity
  if (numA !== numB) return numA - numB
  return new Date(a.created) - new Date(b.created)
}

function comicsSeriesRepresentatives(comics) {
  const seriesMap = new Map()

  for (const comic of comics) {
    if (comic.serie_id == null) continue
    const existing = seriesMap.get(comic.serie_id)
    if (!existing || compareTome(comic, existing) < 0) {
      seriesMap.set(comic.serie_id, comic)
    }
  }

  return [...seriesMap.values()]
}

export function isStandaloneComic(comic) {
  return !String(comic?.serie || '').trim()
}

export function filterComicsByDisplayMode(comics, mode) {
  if (mode === 'series') return comicsSeriesRepresentatives(comics)
  if (mode === 'singles') return comics.filter(isStandaloneComic)
  return comics
}

export function comicPosterLink(comic, displayMode = 'series') {
  if (displayMode === 'series' && comic?.serie_id != null) {
    return { name: 'ComicSerieDetail', params: { serieId: comic.serie_id } }
  }
  return { name: 'ComicDetail', params: { id: comic.id } }
}
